// import React,{useState, useRef} from "react";











// export default function Form() {

//   const handleSubmit = () => {
    
//     alert("فۆرمەکە نێردرا ✅");
//   };

//     const [preview, setPreview] = useState(null);
//       const fileRef = useRef(null);

//   const handleImageChange = (e) => {
//     const file = e.target.files && e.target.files[0];

//     if (!file) return; // ✅ prevent createObjectURL error

//     setPreview(URL.createObjectURL(file));
//   };

//   const resetImage = () => {
//     setPreview(null);

//     if (fileRef.current) {
//       fileRef.current.value = ""; // ✅ safe reset
//     }
//   };

//      const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     city: "",
//     note: "",
//   });



//   return (
//     <form className="tally-form" style={{paddingRight:120}}>

//       {/* Full Name */}
//       <div className="mb-5">
//         <label className="form-label fw-semibold" style={{color:"green", fontSize:25}}>
//           ناوی تەواو
//         </label>
//         <p>(وەکوو ناوی ناسنامە بێت)</p>
//         <input
//           type="text"
//           className="form-control form-control-lg"
//           placeholder="ناوی تەواوت بنووسە"
//           required
//         />
//       </div>

//       {/* Degree */}
//   <div className="mb-5">
//   <label className="form-label fw-semibold d-block" style={{color:"green", fontSize:25}}>
//     بڕوانامە
//   </label>

//   <div className="tally-radio-group">

//     <label className="tally-radio">
//       <input type="radio" name="degree" value="bachelor" />
//       <span>بەکالۆریۆس</span>
//     </label>

//     <label className="tally-radio">
//       <input type="radio" name="degree" value="master" />
//       <span>ماستەر</span>
//     </label>
//     <label className="tally-radio">
//       <input type="radio" name="degree" value="phd" />
//       <span>دکتۆرا</span>
//     </label>

//   </div>
// </div>

// <div className="mb-5">
//         <label className="form-label fw-semibold" style={{color:"green", fontSize:25}}>
//          ئەزموون بە ساڵ
//         </label>
        
//         <input
//           type="text"
//           className="form-control form-control-lg"
//           placeholder="٤"
//           required
//         />
//       </div>

//       <div className="mb-5">
//   <label className="form-label fw-semibold d-block" style={{color:"green", fontSize:25}}>
//     پلەی پارێزەرایەتی
//   </label>

//   <div className="tally-radio-group">

//     <label className="tally-radio">
//       <input type="radio" name="degree" value="rahenraw" />
//       <span>ڕاهینراو</span>
//     </label>

//     <label className="tally-radio">
//       <input type="radio" name="degree" value="kara" />
//       <span>کارا</span>
//     </label>
//     <label className="tally-radio">
//       <input type="radio" name="degree" value="rawezhkar" />
//       <span>ڕاوێژکار</span>
//     </label>

//   </div>
// </div>


//       <div className="mb-5">
//         <label className="form-label fw-semibold" style={{color:"green", fontSize:25}}>
//           لە کام شاری کوردستانیت؟
//         </label>
//         <input
//           type="text"
//           className="form-control form-control-lg"
//           placeholder="ناوی شارەکەت"
//           required
//         />
//       </div>

//       {/* Upload Image */}
//       <div className="mb-5" >
//         <label className="form-label fw-semibold d-block"  style={{color:"green", fontSize:25}}>
//          وێنەی کەسی
//         </label>

//         <p>(تکایە وێنەکە چوارگۆشەبێت و ڕوخسار لە ناوەڕاستبێت)</p>
//         <p>تێبینی: ئەگەر نەتانتوانی ئەپلۆدی بکەن ئەوا لە تێلیگرام یان وەتسئەپ بنێرن بۆمان(٠٧٥١٦٦٠٦٠٦١)</p>

//         <label className="tally-upload">
//           <input
//            ref={fileRef}
//             type="file"
//             accept="image/*"
//             onChange={handleImageChange}
//           />

//           {preview ? (
//             <>
//             <img
//               src={preview}
//               alt="Preview"
//               className="upload-preview"
//             />
//             <button
//                 type="button"
//                 className="btn btn-outline-success btn-sm mt-3"
//                 onClick={resetImage}
//               >
//                 وێنە بسڕەوە
//               </button>

//               </>
//           ) : (
//             <span>کلیک بکە بۆ هەڵبژاردنی وێنە</span>
//           )}
//         </label>
//       </div>


//              <div className="mb-5">
//   <label className="form-label fw-semibold d-block" style={{color:"green", fontSize:25}}>
//     ڕەگەز
//   </label>

//   <div className="tally-radio-group">

//     <label className="tally-radio">
//       <input type="radio" name="degree" value="male" />
//       <span>نێر</span>
//     </label>

//     <label className="tally-radio">
//       <input type="radio" name="degree" value="female" />
//       <span>مێ</span>
//     </label>
   

//   </div>
// </div>



//       {/* Phone */}
//       <div className="mb-5" >
//         <label className="form-label fw-semibold" style={{color:"green", fontSize:25}}>
//           ژمارەی مۆبایل
//         </label>
//         <p>تکایە وەتسئەپ و تێلیگرام لەسەربێت</p>
//         <input
//           type="tel"
//           className="form-control form-control-lg"
//           placeholder="0750xxxxxxx"
//           required
//         />
//       </div>
//       {/* Phone */}
//       <div className="mb-5" style={{color:"green", fontSize:25}}>
//         <label className="form-label fw-semibold">
//          ژمارەی مۆبایل دووەم
//         </label>
//         <input
//           type="tel"
//           className="form-control form-control-lg"
//           placeholder="0750xxxxxxx"
//         />
//       </div>

//       {/* Email */}
//       <div className="mb-5" style={{color:"green", fontSize:25}}>
//         <label className="form-label fw-semibold">
//           ئیمەیڵ
//         </label>
//         <input
//           type="email"
//           className="form-control form-control-lg"
//           placeholder="example@email.com"
          
//         />
//       </div>

//       <div className="mb-5" style={{color:"green", fontSize:25}} >
//         <label className="form-label fw-semibold">
//           لینکی سۆشیاڵ میدیا
//         </label>
//         <div className="tally-radio-group">
//         <input
//           type="url"
//           className="form-control form-control-lg social-input"
//           placeholder="Facebook"
//           dir="ltr"
//         />
//         <input
//           type="url"
//           className="form-control form-control-lg social-input"
//           placeholder="Instagram"
//           dir="ltr"
//         />
//         <input
//           type="url"
//           className="form-control form-control-lg social-input"
//           placeholder="TikTok"
//           dir="ltr"
//         />
//         <input
//           type="url"
//           className="form-control form-control-lg social-input"
//           placeholder="Linkedin"
//           dir="ltr"
//         />
//         <input
//           type="url"
//           className="form-control form-control-lg social-input"
//           placeholder="Snapchat"
//           dir="ltr"
//         />
//         </div>
//       </div>


//       <div className="mb-5">
//         <label className="form-label fw-semibold" style={{color:"green", fontSize:25}}>
//           ناونیشانی ئۆفیس
//         </label>
//         <p>ئەگەر نییە بەجێی بێڵە</p>
//         <input
//           type="text"
//           className="form-control form-control-lg"
//           placeholder="ناوی شارەکەت"
//           required
//         />
//       </div>


//       {/* Categories */}
// <div className="mb-5">
//   <label className="form-label fw-semibold d-block" style={{marginBottom:30, color:"green", fontSize:25}}>
//     پسپۆڕی پسپۆڕی (کەتەگۆری)
//   </label>

//   <div className="checkbox-group">

//     <label className="checkbox-card">
//       <input type="checkbox" value="tech" />
//       <span>شارستانی</span>
//     </label>

//     <label className="checkbox-card">
//       <input type="checkbox" value="design" />
//       <span>سزادان</span>
//     </label>

//     <label className="checkbox-card">
//       <input type="checkbox" value="business" />
//       <span>بار کەسی</span>
//     </label>

//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>کۆمپانیاکان</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>خانووبەرە</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>کار</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>ڕەگەزنامە</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>سەلماندن</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>دادبینی شارستانی</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>تاوان</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>کەتن</span>
//     </label>
    

//   </div>
// </div>
//       {/* language */}
// <div className="mb-5">
//   <label className="form-label fw-semibold d-block" style={{marginBottom:30, color:"green", fontSize:25}}>
//    زانینی زمان
//   </label>

//   <div className="checkbox-group">

//     <label className="checkbox-card">
//       <input type="checkbox" value="tech" />
//       <span>کوردی</span>
//     </label>

//     <label className="checkbox-card">
//       <input type="checkbox" value="design" />
//       <span>عەرەبی</span>
//     </label>

//     <label className="checkbox-card">
//       <input type="checkbox" value="business" />
//       <span>ئینگلیزی</span>
//     </label>

//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>فارسی</span>
//     </label>
//     <label className="checkbox-card">
//       <input type="checkbox" value="education" />
//       <span>تورکی</span>
//     </label>

//   </div>
// </div>

//       {/* Message */}
//       <div className="mb-5" style={{color:"green", fontSize:20}}>
//         <label className="form-label fw-semibold">
//           پێت باشە ئەپی یاسا چ شتێکی تێدابێت بۆ ئەوەی <br/>زیاتر سوود بە پارێزەران بگەیەنێت
//         </label>
//         <textarea
//           className="form-control form-control-lg"
//           rows="4"
//           placeholder="هەر تێبینیەکت هەیە..."
//           required
//         ></textarea>
//       </div>
//        <div className="mb-5">
//         <label className="form-label fw-semibold" style={{color:"green", fontSize:20}}>
//          بە ڕای تۆ مانگانە بڕی چەند پارە وەربگیرێت لە پارێزەران<br/> لە بەرامبەر پێشکەش کردنی خزمەتگوزاری ئەپی یاسا
//         </label>
        
//         <input
//           type="text"
//           className="form-control form-control-lg"
//           required
//         />
//       </div>

//       {/* Submit */}
//       <div className="d-flex">
//         <button type="submit" className="btn btn-success btn-lg" style={{maxWidth: '420px'}} onClick={handleSubmit}>
//           ناردن 
//         </button>
//       </div>

//     </form>
//   );
// }


import React, { useState, useRef } from "react";
import { createClient } from "@supabase/supabase-js";

// --- SUPABASE CONFIGURATION ---
const supabaseUrl = "https://rextzqlyqfiwqagcksuj.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJleHR6cWx5cWZpd3FhZ2Nrc3VqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg2NjA1MTgsImV4cCI6MjA4NDIzNjUxOH0.opWfhudaD3KOTg4HlOGZdLN19PynfCdXA2hwp-DVm-Y";
const supabase = createClient(supabaseUrl, supabaseKey);

export default function Form() {
  const fileRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  // Form State
  const [form, setForm] = useState({
    name: "",
    degree: "",
    experience: "",
    rank: "",
    city: "",
    gender: "",
    phone1: "",
    phone2: "",
    email: "",
    social_fb: "",
    social_ig: "",
    social_tt: "",
    social_li: "",
    social_sc: "",
    office_address: "",
    categories: [],
    languages: [],
    suggestion: "",
    expected_price: "",
  });

  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      const field = name === "category" ? "categories" : "languages";
      const updatedList = checked
        ? [...form[field], value]
        : form[field].filter((item) => item !== value);
      setForm({ ...form, [field]: updatedList });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const resetImage = () => {
    setPreview(null);
    setSelectedFile(null);
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setUploading(true);

  //   try {
  //     let imageUrl = "";

  //     // 1. Upload Image to Supabase Storage (if exists)
  //     if (selectedFile) {
  //       const fileExt = selectedFile.name.split(".").pop();
  //       const fileName = `${Math.random()}.${fileExt}`;
  //       const filePath = `avatars/${fileName}`;

  //       const { error: uploadError } = await supabase.storage
  //         .from("images") // Ensure you have a bucket named 'images'
  //         .upload(filePath, selectedFile);

  //       if (uploadError) throw uploadError;

  //       const { data: publicUrlData } = supabase.storage
  //         .from("images")
  //         .getPublicUrl(filePath);
        
  //       imageUrl = publicUrlData.publicUrl;
  //     }

  //     // 2. Insert Data into Supabase Table
  //     const { error } = await supabase.from("lawyers").insert([
  //       {
  //         full_name: form.name,
  //         degree: form.degree,
  //         experience_years: form.experience,
  //         lawyer_rank: form.rank,
  //         city: form.city,
  //         profile_image: imageUrl,
  //         gender: form.gender,
  //         phone_primary: form.phone1,
  //         phone_secondary: form.phone2,
  //         email: form.email,
  //         social_links: {
  //           facebook: form.social_fb,
  //           instagram: form.social_ig,
  //           tiktok: form.social_tt,
  //           linkedin: form.social_li,
  //           snapchat: form.social_sc,
  //         },
  //         office_address: form.office_address,
  //         specialties: form.categories,
  //         languages: form.languages,
  //         user_suggestion: form.suggestion,
  //         pricing_opinion: form.expected_price,
  //       },
  //     ]);

  //     if (error) throw error;

  //     alert("فۆرمەکە بە سەرکەوتوویی نێردرا ✅");
  //     // Reset form logic here if needed
  //   } catch (error) {
  //     alert("هەڵەیەک ڕوویدا: " + error.message);
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setUploading(true);

  try {
    // 1. CHECK IF USER ALREADY EXISTS
    // We check by primary phone number, but you can change 'phone1' to 'email' if you prefer
    const { data: existingUser, error: checkError } = await supabase
      .from("lawyers")
      .select("id")
      .eq("phone_primary", form.phone1) 
      .maybeSingle(); // This returns one row or null

    if (checkError) throw checkError;

    if (existingUser) {
      alert("ببوورە، ئەم زانیاریانە پێشتر نێردراون! ❌\nYou have already submitted the form.");
      setUploading(false);
      return; // Stop the function here
    }

    let imageUrl = "";

    // 2. IMAGE UPLOAD LOGIC
    if (selectedFile) {
      // const fileExt = selectedFile.name.split(".").pop();
      // const fileName = `${Math.random()}.${fileExt}`;
      // const filePath = `avatars/${fileName}`;
      const fileExt = selectedFile.name.split(".").pop();

      const fileName = `${form.phone1}_${Date.now()}.${fileExt}`;
      const filePath = `avatars/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from("images")
        .upload(filePath, selectedFile);

      if (uploadError) throw uploadError;

      const { data: publicUrlData } = supabase.storage
        .from("images")
        .getPublicUrl(filePath);
      
      imageUrl = publicUrlData.publicUrl;
    }

    // 3. DATABASE INSERT LOGIC
    const { error } = await supabase.from("lawyers").insert([
      {
        full_name: form.name,
        degree: form.degree,
        experience_years: form.experience,
        lawyer_rank: form.rank,
        city: form.city,
        profile_image: imageUrl,
        gender: form.gender,
        phone_primary: form.phone1,
        phone_secondary: form.phone2,
        email: form.email,
        social_links: {
          facebook: form.social_fb,
          instagram: form.social_ig,
          tiktok: form.social_tt,
          linkedin: form.social_li,
          snapchat: form.social_sc,
        },
        office_address: form.office_address,
        specialties: form.categories,
        languages: form.languages,
        user_suggestion: form.suggestion,
        pricing_opinion: form.expected_price,
      },
    ]);

    if (error) throw error;

    // 4. SUCCESS & RESET
    alert("فۆرمەکە بە سەرکەوتوویی نێردرا ✅");
    
    // Reset Form State
    setForm({
      name: "", degree: "", experience: "", rank: "", city: "",
      gender: "", phone1: "", phone2: "", email: "",
      social_fb: "", social_ig: "", social_tt: "", social_li: "", social_sc: "",
      office_address: "", categories: [], languages: [],
      suggestion: "", expected_price: "",
    });

    resetImage(); // Clear preview and file ref
    e.target.reset(); // Clear HTML UI

  } catch (error) {
    alert("ببوورە، ئەم زانیاریانە پێشتر نێردراون! ❌\nYou have already submitted the form.");
  } finally {
    setUploading(false);
  }
};

  return (
    <form className="tally-form" style={{ paddingRight: 100 }} onSubmit={handleSubmit}>
      {/* Full Name */}
      <div className="mb-5">
        <label className="form-label fw-semibold" style={{ color: "green", fontSize: 25 }}>
          ناوی تەواو
        </label>
        <p>(وەکوو ناوی ناسنامە بێت)</p>
        <input
          type="text"
          name="name"
          className="form-control form-control-lg"
          placeholder="ناوی تەواوت بنووسە"
          required
          onChange={handleInputChange}
        />
      </div>

      {/* Degree */}
      <div className="mb-5">
        <label className="form-label fw-semibold d-block" style={{ color: "green", fontSize: 25 }}>
          بڕوانامە
        </label>
        <div className="tally-radio-group">
          {["بەکالۆریۆس", "ماستەر", "دکتۆرا"].map((deg) => (
            <label className="tally-radio" key={deg}>
              <input type="radio" name="degree" value={deg} onChange={handleInputChange} />
              <span>{deg === "بەکالۆریۆس" ? "بەکالۆریۆس" : deg === "ماستەر" ? "ماستەر" : "دکتۆرا"}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Experience */}
      <div className="mb-5">
        <label className="form-label fw-semibold" style={{ color: "green", fontSize: 25 }}>
          ئەزموون بە ساڵ
        </label>
        <input
          type="text"
          name="experience"
          className="form-control form-control-lg"
          placeholder="٤"
          required
          onChange={handleInputChange}
        />
      </div>

      {/* Rank */}
      <div className="mb-5">
        <label className="form-label fw-semibold d-block" style={{ color: "green", fontSize: 25 }}>
          پلەی پارێزەرایەتی
        </label>
        <div className="tally-radio-group">
          <label className="tally-radio">
            <input type="radio" name="rank" value="ڕاهێنراو" onChange={handleInputChange} />
            <span>ڕاهینراو</span>
          </label>
          <label className="tally-radio">
            <input type="radio" name="rank" value="کارا" onChange={handleInputChange} />
            <span>کارا</span>
          </label>
          <label className="tally-radio">
            <input type="radio" name="rank" value="ڕاوێژکار" onChange={handleInputChange} />
            <span>ڕاوێژکار</span>
          </label>
        </div>
      </div>

      {/* City */}
      <div className="mb-5">
        <label className="form-label fw-semibold" style={{ color: "green", fontSize: 25 }}>
          لە کام شاری کوردستانیت؟
        </label>
        <input
          type="text"
          name="city"
          className="form-control form-control-lg"
          placeholder="ناوی شارەکەت"
          required
          onChange={handleInputChange}
        />
      </div>

      {/* Upload Image */}
      <div className="mb-5">
        <label className="form-label fw-semibold d-block" style={{ color: "green", fontSize: 25 }}>
          وێنەی کەسی
        </label>
        <p>(تکایە وێنەکە چوارگۆشەبێت و ڕوخسار لە ناوەڕاستبێت)</p>
        <label className="tally-upload">
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            onChange={handleImageChange}
          />
          {preview ? (
            <>
              <img src={preview} alt="Preview" className="upload-preview" />
              <button type="button" className="btn btn-outline-success btn-sm mt-3" onClick={resetImage}>
                وێنە بسڕەوە
              </button>
            </>
          ) : (
            <span>کلیک بکە بۆ هەڵبژاردنی وێنە</span>
          )}
        </label>
      </div>

      {/* Gender */}
      <div className="mb-5">
        <label className="form-label fw-semibold d-block" style={{ color: "green", fontSize: 25 }}>
          ڕەگەز
        </label>
        <div className="tally-radio-group">
          <label className="tally-radio">
            <input type="radio" name="gender" value="نێر" onChange={handleInputChange} />
            <span>نێر</span>
          </label>
          <label className="tally-radio">
            <input type="radio" name="gender" value="مێ" onChange={handleInputChange} />
            <span>مێ</span>
          </label>
        </div>
      </div>

      {/* Phone Numbers */}
      <div className="mb-5">
        <label className="form-label fw-semibold" style={{ color: "green", fontSize: 25 }}>
          ژمارەی مۆبایل
        </label>
        <input
          type="tel"
          name="phone1"
          className="form-control form-control-lg"
          placeholder="0750xxxxxxx"
          required
          onChange={handleInputChange}
        />
      </div>
      <div className="mb-5" style={{ color: "green", fontSize: 25 }}>
        <label className="form-label fw-semibold">ژمارەی مۆبایل دووەم</label>
        <input
          type="tel"
          name="phone2"
          className="form-control form-control-lg"
          placeholder="0750xxxxxxx"
          onChange={handleInputChange}
        />
      </div>

      {/* Email */}
      <div className="mb-5" style={{ color: "green", fontSize: 25 }}>
        <label className="form-label fw-semibold">ئیمەیڵ</label>
        <input
          type="email"
          name="email"
          className="form-control form-control-lg"
          placeholder="example@email.com"
          onChange={handleInputChange}
        />
      </div>

      {/* Social Media */}
      <div className="mb-5" style={{ color: "green", fontSize: 25 }}>
        <label className="form-label fw-semibold">لینکی سۆشیاڵ میدیا</label>
        <div className="tally-radio-group">
          <input name="social_fb" type="url" className="form-control form-control-lg social-input" placeholder="Facebook" dir="ltr" onChange={handleInputChange} />
          <input name="social_ig" type="url" className="form-control form-control-lg social-input" placeholder="Instagram" dir="ltr" onChange={handleInputChange} />
          <input name="social_tt" type="url" className="form-control form-control-lg social-input" placeholder="TikTok" dir="ltr" onChange={handleInputChange} />
          <input name="social_li" type="url" className="form-control form-control-lg social-input" placeholder="Linkedin" dir="ltr" onChange={handleInputChange} />
        </div>
      </div>

       {/* office location */}
      <div className="mb-5">
        <label className="form-label fw-semibold" style={{ color: "green", fontSize: 25 }}>
          ناونیشانی ئۆفیس
        </label>
        <input
          type="text"
          name="office_address"
          className="form-control form-control-lg"
          placeholder="ناونیشانی ئۆفیس"
          onChange={handleInputChange}
        />
      </div>

      {/* Categories Checkboxes */}
      <div className="mb-5">
        <label className="form-label fw-semibold d-block" style={{ marginBottom: 30, color: "green", fontSize: 25 }}>
          پسپۆڕی (کەتەگۆری)
        </label>
        <div className="checkbox-group">
          {["شارستانی", "سزادان", "بار کەسی", "کۆمپانیاکان", "خانووبەرە", "کار", "ڕەگەزنامە", "سەلماندن", "دادبینی شارستانی", "تاوان", "کەتن"].map((cat) => (
            <label className="checkbox-card" key={cat}>
              <input type="checkbox" name="category" value={cat} onChange={handleInputChange} />
              <span>{cat}</span>
            </label>
          ))}
        </div>
      </div>


      {/* Categories Checkboxes */}
      <div className="mb-5">
        <label className="form-label fw-semibold d-block" style={{ marginBottom: 30, color: "green", fontSize: 25 }}>
          زانینی زمان
        </label>
        <div className="checkbox-group">
          {["کوردی", "عەرەبی", "ئینگلیزی", "فارسی", "تورکی"].map((lang) => (
            <label className="checkbox-card" key={lang}>
              <input type="checkbox" name="languages" value={lang} onChange={handleInputChange} />
              <span>{lang}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Message & Feedback */}
      <div className="mb-5" style={{ color: "green", fontSize: 20 }}>
        <label className="form-label fw-semibold">تێبینی یان پێشنیار</label>
        <textarea
          name="suggestion"
          className="form-control form-control-lg"
          rows="4"
          placeholder="هەر تێبینیەکت هەیە..."
          onChange={handleInputChange}
        ></textarea>
      </div>

      <div className="mb-5">
        <label className="form-label fw-semibold" style={{ color: "green", fontSize: 20 }}>
          نرخی پێشنیارکراو بۆ مانگانە
        </label>
        <input
          name="expected_price"
          type="text"
          className="form-control form-control-lg"
          onChange={handleInputChange}
        />
      </div>

      {/* Submit */}
      <div className="d-flex">
        <button
          type="submit"
          disabled={uploading}
          className="btn btn-success btn-lg"
          style={{ maxWidth: "420px" }}
        >
          {uploading ? "خەریکی ناردنە..." : "ناردن"}
        </button>
      </div>
    </form>
  );
}